import React from "react";
import { useEmployeeReviewers } from "../hooks/use-employee-reviewers";

export default function ReviewerCoverageCount({ employeeId, quadId }) {
  const { reviewers, isLoading } = useEmployeeReviewers({ employeeId, quadId });
  if (isLoading) return <span className="text-xs text-muted-foreground">–</span>;
  return <span className="text-sm font-medium">{reviewers.length}</span>;
}
